import styled from "styled-components"
import theme from "./theme-main"
import { media } from "utils/utils"

export const Wrapper = styled.div`
  width: 60px;
  height: 60px;
  position: fixed;
  top: 0;
  left: ${props =>
    props.variant && props.variant === "right" ? "auto" : "-1px"};
  right: ${props =>
    props.variant && props.variant === "right" ? "-1px" : "auto"};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-right: ${props =>
    props.variant && props.variant === "right"
      ? "none"
      : "1px solid" + theme.colors.textSection};
  border-left: ${props =>
    props.variant && props.variant === "left"
      ? "none"
      : "1px solid" + theme.colors.textSection};
  background-color: ${props =>
    props.isOpen ? props.theme.colors.light : "transparent"};
  z-index: 999;
`

export const MenuIcon = styled.div`
  width: 20px;
  height: 20px;
  color: ${props =>
    props.isOpen
      ? props.theme.colors.textPrimary
      : props.color
      ? props.color
      : props.theme.colors.light};
  transition: all 0.2s ease-out;

  &:hover {
    color: ${props => props.theme.colors.inactive};
  }

  :focus-visible {
    outline: 2px solid #015ecc !important;
  }
`

export const MenuWrapper = styled.div`
  padding: 10px 0 0;
  position: absolute;
  top: 100%;
  left: ${props => (props.variant && props.variant === "right" ? "auto" : 0)};
  right: ${props =>
    props.variant && props.variant === "right" ? "-79px" : "auto"};
  width: 280px;
  background: ${props => props.theme.colors.light};
  box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease-out;
  visibility: ${props => (props.isOpen ? "visible" : "hidden")};
  opacity: ${props => (props.isOpen ? 1 : 0)};

  ${media.md`
    position: fixed;
    top:60px;
    left: 0;
    right:0;
    bottom: 0
    width:100%;
    padding: ${props =>
      props.extraMobilePadding ? "40px 28px 0 27px" : "40px 18px 0 17px"};
    z-index: 9;
  `};
`

export const MenuItem = styled.div`
  display: block;
  vertical-align: middle;
  padding: 0 32px;
  cursor: pointer;
  transition: all 0.2s ease-out;
  margin: 0 10px;
  a {
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: 14px;
    color: ${props => props.theme.colors.textSecondaryDark};
    text-decoration: none;
    display: block;
    padding: 15px 0;
    margin-bottom: 10px;

    &:hover {
      font-weight: bold;
      color: ${props => props.theme.colors.light} !important;
    }

    ${media.md`
      font-size: 16px;
      padding:15px 10px;
    `};
  }

  &:hover {
    color: ${props => props.theme.colors.light};
    background: ${props => props.theme.colors.vantageHighlight};
  }

  ${media.md`
 
    margin:0;
    padding:0;
  `};
`

export const NarrowMenuItem = styled.div`
  display: block;
  vertical-align: middle;
  padding: 0 20px;
  cursor: pointer;
  transition: all 0.2s ease-out;
  margin: 0 10px;
  a {
    text-transform: uppercase;
    letter-spacing: 3px;
    font-size: 14px;
    color: ${props => props.theme.colors.textSecondaryDark};
    text-decoration: none;
    display: block;
    padding: 15px 0;
    margin-bottom: 10px;

    &:hover {
      font-weight: bold;
      color: ${props => props.theme.colors.light} !important;
    }

    ${media.md`
      padding:15px 10px;
    `};
  }

  &:hover {
    color: ${props => props.theme.colors.light};
    background: ${props => props.theme.colors.vantageHighlight};
  }

  ${media.md`
    padding:0;
    margin:0;
    
    a {
      font-size: 16px;
      
    }
  `};
`
